import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

firebase.initializeApp({
  apiKey: 'AIzaSyCG8hGDMUPv3Ng5GuuAFZ0uXzYTCZMA-fI',
  authDomain: 'client-flatmap.firebaseapp.com',
  databaseURL: 'https://client-flatmap.firebaseio.com',
  projectId: 'client-flatmap',
  storageBucket: 'client-flatmap.appspot.com',
  messagingSenderId: '317568945608'
});

export default firebase;
